const couponInfo = []
const couponInfoExpired = []

export default {
  couponInfo,
  couponInfoExpired
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-coupon/store/state.js